import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class EsploroMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        const key = params.key;
        //return key.split('.').reverse()[0];
        return '';
    }
}
